export const HANDLE_FETCH_STUDENTS = "HANDLE_FETCH_STUDENTS";

export interface IHandleFetchStudents {
  type: typeof HANDLE_FETCH_STUDENTS;
}

export interface IUnassignStudentFromLocation {
  locations: TLocation[];
  studentId: string;
}

export const HANDLE_FETCH_ALL_STUDENTS = "HANDLE_FETCH_ALL_STUDENTS";

export interface IHandleFetchAllStudents {
  type: typeof HANDLE_FETCH_ALL_STUDENTS;
}

export const SET_STUDENT_ACTION_SPINNER = "SET_STUDENT_ACTION_SPINNER";

export const HANDLE_DELETE_MULTIPLE_ITEMS_FROM_STUDENT =
  "HANDLE_DELETE_MULTIPLE_ITEMS_FROM_STUDENT";

export interface IHandleDeleteMultipleItems {
  type: typeof HANDLE_DELETE_MULTIPLE_ITEMS_FROM_STUDENT;
  payload: DeleteRequest;
  studentId: string;
}

export const HANDLE_FETCH_STUDENT_CALENDAR_DATA = "HANDLE_FETCH_STUDENT_CALENDAR_DATA";

export interface IHandleFetchStudentCalendarData {
  type: typeof HANDLE_FETCH_STUDENT_CALENDAR_DATA;
  payload: string;
}

export const HANDLE_OPEN_SELECTED_ITEM_DETAILS = "HANDLE_OPEN_SELECTED_ITEM_DETAILS";

export interface IHandleOpenSelectedItemDetails {
  type: typeof HANDLE_OPEN_SELECTED_ITEM_DETAILS;
  payload: OpenDetailsRequest;
}

export const HANDLE_MANAGE_STUDENT_ENROLLMENTS = "HANDLE_MANAGE_STUDENT_ENROLLMENTS";

export interface IHandleManageStudentEnrollments {
  type: typeof HANDLE_MANAGE_STUDENT_ENROLLMENTS;
  payload: StudentEnrollmentsPayload;
}

export const HANDLE_UPDATE_STUDENT_ACCOUNT = "HANDLE_UPDATE_STUDENT_ACCOUNT";

export interface IHandleUpdateStudentAccount {
  type: typeof HANDLE_UPDATE_STUDENT_ACCOUNT;
  payload: UpdateStudentAccount;
  source: UpdateSource;
}

export const HANDLE_FETCH_STUDENT = "HANDLE_FETCH_STUDENT";

export interface IHandleFetchStudent {
  type: typeof HANDLE_FETCH_STUDENT;
  payload: string;
}

export const HANDLE_ASSIGN_INSTRUCTOR_TO_STUDENT = "HANDLE_ASSIGN_INSTRUCTOR_TO_STUDENT";

export interface IHandleAssignInstructorToStudent {
  type: typeof HANDLE_ASSIGN_INSTRUCTOR_TO_STUDENT;
  payload: AssignInstructorToStudent;
}

export const HANDLE_ARCHIVE_STUDENTS = "HANDLE_ARCHIVE_STUDENTS";

export interface IHandleArchiveStudents {
  type: typeof HANDLE_ARCHIVE_STUDENTS;
  payload: ArchiveStudentsPayload;
}

export const HANDLE_UPDATE_STUDENT_TARGET_SCORE = "HANDLE_UPDATE_STUDENT_TARGET_SCORE";

export const HANDLE_UPDATE_STUDENT_REPORT = "HANDLE_UPDATE_STUDENT_TARGET_SCORE";

export interface IHandleUpdateStudentReport {
  type: typeof HANDLE_UPDATE_STUDENT_REPORT;
  payload: StudentReport;
}

export const HANDLE_UPDATE_STUDENT_PROFILE = "HANDLE_UPDATE_STUDENT_PROFILE";

export interface IHandleUpdateStudentProfile {
  type: typeof HANDLE_UPDATE_STUDENT_PROFILE;
  payload: UpdateStudentProfile;
  source: UpdateSource;
}

export const HANDLE_UPDATE_STUDENT = "HANDLE_UPDATE_STUDENT";

export interface IHandleUpdateStudent {
  type: typeof HANDLE_UPDATE_STUDENT;
  payload: UpdateStudent;
}

export const HANDLE_UPDATE_STUDENT_ADDRESS = "HANDLE_UPDATE_STUDENT_ADDRESS";

export interface IHandleUpdateStudentAddress {
  type: typeof HANDLE_UPDATE_STUDENT_ADDRESS;
  payload: UpdateStudentAddress;
}

export const HANDLE_FETCH_STUDENTS_STATISTICS = "HANDLE_FETCH_STUDENTS_STATISTICS";

export interface IHandleFetchStudentsStatistics {
  type: typeof HANDLE_FETCH_STUDENTS_STATISTICS;
}

export const SET_STUDENTS_STATISTICS = "STUDENTS_STATISTICS";

export interface ISetStudentsStatistics {
  type: typeof SET_STUDENTS_STATISTICS;
  payload: StudentStatistics;
}

export const SET_STUDENTS = "SET_STUDENTS";

export interface ISetStudents {
  type: typeof SET_STUDENTS;
  payload: Student[];
}

export const HANDLE_DELETE_STUDENT = "HANDLE_DELETE_STUDENT";

export interface IHandleDeleteStudent {
  type: typeof HANDLE_DELETE_STUDENT;
  payload: string;
}

export const HANDLE_FETCH_STUDENT_SESSIONS = "HANDLE_FETCH_STUDENT_SESSIONS";

export interface IHandleFetchStudentSessions {
  type: typeof HANDLE_FETCH_STUDENT_SESSIONS;
}

export const SET_ACTIVE_STUDENT = "SET_ACTIVE_STUDENT";

export interface ISetActiveStudent {
  type: typeof SET_ACTIVE_STUDENT;
  payload: Student;
}

export const HANDLE_UPDATE_STUDENT_REPORT_LOCALLY = "HANDLE_UPDATE_STUDENT_REPORT_LOCALLY";

export interface IHandleUpdateStudentReportLocally {
  type: typeof HANDLE_UPDATE_STUDENT_REPORT_LOCALLY;
  payload: {
    report: StudentReport;
    studentId: string;
  };
}

export const HANDLE_SEND_STUDENT_REPORT = "HANDLE_SEND_STUDENT_REPORT";

export interface IHandleSendStudentReport {
  type: typeof HANDLE_SEND_STUDENT_REPORT;
  payload: StudentReportRequest;
}

export const HANDLE_FETCH_STUDENT_REPORT_PREVIEW = "HANDLE_FETCH_STUDENT_REPORT_PREVIEW";

export interface IFetchStudentReportPreview {
  type: typeof HANDLE_FETCH_STUDENT_REPORT_PREVIEW;
  payload: string;
}

export const SET_STUDENT_REPORT_PREVIEW = "SET_STUDENT_REPORT_PREVIEW";

export interface ISetStudentReportPreview {
  type: typeof SET_STUDENT_REPORT_PREVIEW;
  payload: Blob;
}

export const HANDLE_UPDATE_STUDENT_ACTIVATION = "HANDLE_UPDATE_STUDENT_ACTIVATION";

export interface IHandleUpdateStudentActivation {
  type: typeof HANDLE_UPDATE_STUDENT_ACTIVATION;
  payload: UpdateStudentActivationPayload;
  source: "details" | "list";
}

export const SET_STUDENT_SUMMARY = "SET_STUDENT_SUMMARY";

export interface ISetStudentSummary {
  type: typeof SET_STUDENT_SUMMARY;
  payload: StudentSummary;
}

export const SET_STUDENT_SESSIONS = "SET_STUDENT_SESSIONS";

export interface ISetStudentSessions {
  type: typeof SET_STUDENT_SESSIONS;
  payload: Session[];
}

export const HANDLE_CREATE_STUDENT_SESSIONS = "HANDLE_CREATE_STUDENT_SESSIONS";

export interface IHandleCreateStudentSessions {
  type: typeof HANDLE_CREATE_STUDENT_SESSIONS;
  payload: CreateStudentSessionsPayload;
}

export const HANDLE_UPDATE_STUDENT_SESSION = "HANDLE_UPDATE_STUDENT_SESSION";

export interface IHandleUpdateStudentSession {
  type: typeof HANDLE_UPDATE_STUDENT_SESSION;
  payload: Partial<ISessionRequest>;
}

export const HANDLE_ADD_STUDENT_TO_LOCATION = "HANDLE_ADD_STUDENT_TO_LOCATION";

export interface IHandleAddStudentToLocation {
  type: typeof HANDLE_ADD_STUDENT_TO_LOCATION;
  payload: AddStudentLocationsPayload;
}

export const HANDLE_CREATE_NEW_STUDENT = "HANDLE_CREATE_NEW_STUDENT";

export interface IHandleCreateNewStudent {
  type: typeof HANDLE_CREATE_NEW_STUDENT;
  payload: FormDataUserProfile;
  target: "student" | "instructor" | "classroom";
}

export const HANDLE_REMOVE_INSTRUCTOR_FROM_STUDENT = "HANDLE_REMOVE_INSTRUCTOR_FROM_STUDENT";

export interface IHandleRemoveInstructorFromStudent {
  type: typeof HANDLE_REMOVE_INSTRUCTOR_FROM_STUDENT;
  payload: RemoveInstructorFromStudentPayload;
}

export const HANDLE_DOWNLOAD_STUDENT_SYLLABUS = "HANDLE_DOWNLOAD_STUDENT_SYLLABUS";

export interface IHandleDownloadStudentSyllabus {
  type: typeof HANDLE_DOWNLOAD_STUDENT_SYLLABUS;
  payload: {
    body: DownloadStudentSyllabusApi;
  };
}
